module.exports = __webpack_public_path__ + "img/video-icono-back.826c58f5.svg";